import React, { FC } from 'react'

import { IconMonitorBrightnessProps } from './IconMonitorBrightness.types'
import * as Styled from './styles/IconMonitorBrightness.style'

import { nonThemeableRules } from '../../ruleSet'

const IconMonitorBrightness: FC<IconMonitorBrightnessProps> = ({
  size = nonThemeableRules.defaultSize as number as IconMonitorBrightnessProps['size'],
  isResponsive = false,
}: IconMonitorBrightnessProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M42.953 24A18.952 18.952 0 1 1 24 5.048v0A18.952 18.952 0 0 1 42.953 24v0Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeWidth='2'
        />
        <path
          d='M24 8.107v3.975m-11.24.701 2.813 2.812m-7.455 8.442h3.977m.7 11.243 2.813-2.813m8.442 7.453v-3.978m11.24-.699-2.813-2.81m7.455-8.445h-3.977m-.7-11.24-2.813 2.812'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M24.025 31.828a7.815 7.815 0 1 0 0-15.63 7.815 7.815 0 0 0 0 15.63Zm0-15.628v15.627'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconMonitorBrightness
